import { Injectable } from '@angular/core';
import { ValidatorFn, FormGroup } from '@angular/forms';

import {
  EmailValidator,
  RequiredDateValidator,
  VinInvalidCharValidator,
  VinLimitValidator,
  ZipCodeValidator,
} from '@app-core/validations';

@Injectable({
  providedIn: 'root',
})
export class ValidationService {
  static addValidation(validateArray: ValidatorFn[] = [], validation: string): ValidatorFn[] {
    const normalizedValidation = validation.trim ? validation.trim() : validation;

    switch (normalizedValidation) {
      case 'postalcode': {
        validateArray.push(ZipCodeValidator);
        break;
      }
      case 'daterequired': {
        validateArray.push(RequiredDateValidator);
        break;
      }
      case 'email': {
        validateArray.push(EmailValidator);
        break;
      }
      case 'vinlimit': {
        validateArray.push(VinLimitValidator);
        break;
      }
      case 'vininvalidchar': {
        validateArray.push(VinInvalidCharValidator);
        break;
      }
    }

    return validateArray;
  }

  static BusinessFieldValidate(form: FormGroup): void {
    if (form.get('businessFlag')) {
      const businessField = form.get('businessFlag').value;
      if (businessField === 'NO') {
        form.get('businessName').disable();
        form.get('firstName').enable();
        form.get('middleInitial').enable();
        form.get('lastName').enable();
      } else if (businessField === 'YES') {
        form.get('businessName').enable();
        form.get('firstName').disable();
        form.get('middleInitial').disable();
        form.get('lastName').disable();
      }
    }
  }
}
